import store from '../state/store'

store.on('media:sound:volume', function(volume) {
  store.get().ui.set({volume: volume})
  localStorage.setItem('volume', volume)
})

store.on('media:sound:update', function(soundOption) {
  store.get().ui.set({soundOption: soundOption})
  localStorage.setItem('soundOption', soundOption)
})

store.on('media:sound:play', function() {
  const volume = store.get().ui.volume
  const soundOption = store.get().ui.soundOption
  const audio_url = `https://tm2-assets.ams3.cdn.digitaloceanspaces.com/system/assets/sales/sounds/${soundOption}`

  if (audio_url) {
    const audio = new Audio(audio_url)
    audio.volume = volume
    audio.play()
  }
})